
const _ = require('lodash');
const Q = require('q');

const $ = require('jquery');
require('rgs-velocity-animate');

import ko from 'rgs-knockout';

const modals = require('modals');


function withModal (formModule) {
	return function (...args) {
		Q(modals.showOnce(formModule.createForModal(...args))).done();
	};
}

function withInliner (formModule) {
	return function (element) {
		// TODO: createForInliner?
		const { template } = formModule.createForModal(...arguments);

		const $element = $(element);

		$element.css({ visibility: 'hidden' });

		ko.applyBindingsToNode(element, {
			template,
		});

		// fade in
		$element.velocity('fadeIn', { visibility: 'visible' });
	};
}

function withWrappers (formModule) {
	return {
		popup: withModal(formModule),
		inline: withInliner(formModule),
	};
}


const insuranceApplication = require('form-insurance-application');
const callbackLeftMenu = require('callback-left-menu');

module.exports = _.mapValues({
	insuranceApplication,
	callbackLeftMenu,
}, withWrappers);

